import { rem } from 'polished';
import styled from 'styled-components';
import { breakpoints } from '../../styles/theme';

export const Background = styled.div`
    background: ${({ theme }) => theme.colors.darkLight};
`;

export const Video = styled.div``;

export const Player = styled.video`
    width: 100%;
    border-radius: ${rem(14)};

    @media (min-width: ${breakpoints.sm}px) {
        width: 80%;
        margin: 0 10%;
    }
`;
